import * as _ from 'underscore';
import { FormModal } from 'mappMvc/models/modal';
import { ILoadable } from 'mappMvc/interfaces';
import { NewConnection } from '../connections';
import { IConnectionListItem, IGuidObject } from 'mappClient/models';
import { ConnectionModalOptions } from '../interface/options';
import { IConnectionModalData, BaseConnectionClient } from '../interface';
import { NotificationType } from 'mappMvc/enums';
import { FormModalOptions } from 'mappMvc/interfaces/options';
import { Templates } from '../../compile';
import { Util } from 'mappMvc/models';
import { loading, notify } from 'mappMvc/decorators';
import { Localization } from 'mappMvc/compile';

export class NewConnectionModal extends FormModal implements ILoadable {
	private newConnection: NewConnection;
	private connection: KnockoutObservable<IConnectionListItem>;
	private data: KnockoutObservableArray<IConnectionListItem>;

	constructor(options?: ConnectionModalOptions) {
		let newConnection = new NewConnection(options.client, { parent: null });

		options = $.extend(
			true,
			{},
			<FormModalOptions>{
				form: newConnection.getForm,
				width: '60%',
				title: Localization.Studio.Connection.Connection
			},
			options
		);
		super(options);

		newConnection.getForm.template(Templates.forms_fluidNoSubmit);
		newConnection.getForm.ClickedSubmit.unsubscribeAll();
		newConnection.getForm.ClickedSubmit.subscribe(() => {
			this.newConnection.notification.notify(
				Localization.Progress.Validating,
				NotificationType.Hint
			);
			this.newConnection.notification.show();
			this.submit();
		});

		this.newConnection = newConnection;
		this.connection = options.connection;
		this.data = options.data;

		this.Opened.subscribe(() => {
			this.newConnection.reset();
		});
	}

	@loading
	@notify(() => Localization.Saved)
	private submit(): Promise<any> {
		return this.newConnection
			.validate()
			.then(() =>
				(<BaseConnectionClient>this.newConnection.client)
					.saveConnection(this.newConnection.serialize())
					.then((guidObject: IGuidObject) =>
						$.Deferred<IConnectionModalData>().resolve(<IConnectionModalData>{
							connectionId: guidObject.value
						})
					)
			)
			.then((connectionModalData: IConnectionModalData) =>
				(<BaseConnectionClient>this.newConnection.client)
					.getConnections()
					.then((connectionListitems: IConnectionListItem[]) => {
						let deferred = $.Deferred<IConnectionModalData>();
						connectionModalData.data = connectionListitems;
						deferred.resolve(connectionModalData);
						return deferred;
					})
			)
			.then((connectionModalData: IConnectionModalData) => {
				this.data(connectionModalData.data);
				this.connection(
					_.findWhere(connectionModalData.data, {
						id: connectionModalData.connectionId
					})
				);
				this.onOkClicked.notify();
				this.close();
			});
	}

	public loading(state: boolean = true) {
		Util.loading(state, '#' + this.id);
	}
}
